import moment from "@/utils/moment";

export const isUnixTimePassed = (date) => {
  if (!date) return false;
  return date <= Math.round(Date.now() / 1000);
};

export const getUnixTimeInSeconds = (date) => {
  let newDate = new Date();
  if (date) {
    newDate.setTime(date);
  }
  return Math.round(newDate.getTime() / 1000);
};

export const unixTimestampFromTimestampAndHour = (timestamp, hourMinutes) => {
  const newDate = new Date();
  newDate.setTime(timestamp);
  if (!hourMinutes) return Math.round(newDate.getTime() / 1000);

  const [hour, minutes] = hourMinutes.split(":");
  newDate.setHours(hour);
  newDate.setMinutes(minutes);
  newDate.setSeconds(0);
  return Math.round(newDate.getTime() / 1000);
};

export const unixTimestampFromDateAndTime = (date, time) => {
  const newDate = dateFromTime(time, date);
  return Math.round(newDate.getTime() / 1000);
};

export const getDateWithHoursFromDate = (date, dateHours) => {
  const modifiedDate = new Date(date);
  modifiedDate.setHours(dateHours.getHours());
  modifiedDate.setMinutes(dateHours.getMinutes());
  modifiedDate.setSeconds(dateHours.getSeconds());
  modifiedDate.setMilliseconds(0);
  return modifiedDate;
};

export const getStartOfDate = (date) => {
  const modifiedDate = new Date(date);
  modifiedDate.setHours(0);
  modifiedDate.setMinutes(0);
  modifiedDate.setSeconds(0);
  modifiedDate.setMilliseconds(0);
  return modifiedDate;
};

export const getEndOfDate = (date) => {
  const modifiedDate = new Date(date);
  modifiedDate.setHours(23);
  modifiedDate.setMinutes(59);
  modifiedDate.setSeconds(59);
  return modifiedDate;
};

export const dateFromUnixTimestampInSeconds = (timestamp) => {
  if (!timestamp) {
    return null;
  }
  return new Date(timestamp * 1000);
};

export const dateFromTimestamp = (timestamp) => {
  return moment()(dateFromUnixTimestampInSeconds(timestamp)).format("DD/MM/YYYY");
};

export const datetimeFromISODateString = (dateString) => {
  return moment()(dateString).format("DD/MM/YYYY HH:mm");
};

export const datetimeFromISODateStringDayAware = (dateString) => {
  const date = moment()(dateString);
  if (date.isSame(moment()(), "day")) {
    return "a las " + date.format("HH:mm");
  }
  return "el " + date.format("DD/MM/YYYY HH:mm");
};

export const datetimeFromTimestamp = (timestamp) => {
  return moment()(dateFromUnixTimestampInSeconds(timestamp)).format("DD/MM/YYYY HH:mm");
};

export const timeFromTimestamp = (timestamp) => {
  return timeFromDate(dateFromUnixTimestampInSeconds(timestamp));
};

export const timeRangeContains = (from, to, target) => {
  const [fromHours, fromMinutes] = from.split(":");
  const fromVal = parseInt(fromHours) * 60 + parseInt(fromMinutes);
  const [toHours, toMinutes] = to.split(":");
  const toVal = parseInt(toHours) * 60 + parseInt(toMinutes);
  const [targetHours, targetMinutes] = target.split(":");
  const targetVal = parseInt(targetHours) * 60 + parseInt(targetMinutes);

  // Bear in mind that if from is bigger than to we should check also from 00:00 ---> 23:00 - 07:00 we should check > 23 or > 0 and < 7
  if (fromVal > toVal) {
    return targetVal >= fromVal || (targetVal >= 0 && targetVal < toVal);
  } else {
    return targetVal >= fromVal && targetVal < toVal;
  }
};

export const hourFromTimestamp = (timestamp) => {
  return hourFromDate(dateFromUnixTimestampInSeconds(timestamp));
};

export const specialFormatFromTimestamp = (timestamp, format) => {
  return moment()(dateFromUnixTimestampInSeconds(timestamp)).format(format);
};

export const timeFromDate = (date) => {
  return moment()(date).format("HH:mm");
};

export const hourFromDate = (date) => {
  return moment()(date).format("HH");
};

export const formatDate = (date) => {
  if (!date) return "";
  return moment()(date).format("DD/MM/YYYY");
};

export const formatDateTime = (date) => {
  if (!date) return "";
  return moment()(date).format("DD/MM/YYYY HH:mm");
};

export const formatDateForFile = (date) => {
  if (!date) return "";
  return moment()(date).format("DD-MM-YYYY");
};

export const timeFromAnInstant = (date) => {
  if (!date) return "";
  var start = moment()(date * 1000);
  var end = moment()();
  var duration = moment().duration(end.diff(start));
  return moment().utc(duration.asMilliseconds()).format("HH:mm:ss");
};

export const dateFromTime = (time, date) => {
  const parts = time.split(":");
  const newDate = date || new Date();
  newDate.setHours(parts[0]);
  newDate.setMinutes(parts[1]);
  newDate.setSeconds(0);
  return newDate;
};

export const daysBetween = (start, end) => {
  const days = [];
  let current = start;
  while (current <= end) {
    days.push(current);
    current = moment()(current).add(1, "day").toDate();
  }
  return days;
};
